/**
 * @generated SignedSource<<9e43525401ebc2fca2adc2b943a0b444>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TxnClassificationEnum = "CHARGEBACK" | "DIVIDEND" | "FINANCING_FEE" | "FRAUDULENT" | "LOAN_PROCEEDS" | "LOAN_REPAYMENT" | "PROCESSOR_FEE" | "REFUND" | "SALARY" | "TAX_PAYMENT" | "TAX_REFUND" | "%future added value";
export type ClassifyTxnsInputObject = {
  classification?: TxnClassificationEnum | null | undefined;
  txnIds: ReadonlyArray<string>;
};
export type revenueCellPanel_ClassifyTxnsMutation$variables = {
  input: ClassifyTxnsInputObject;
};
export type revenueCellPanel_ClassifyTxnsMutation$data = {
  readonly classifyTxns: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly updatedCount: number;
  } | null | undefined;
};
export type revenueCellPanel_ClassifyTxnsMutation = {
  response: revenueCellPanel_ClassifyTxnsMutation$data;
  variables: revenueCellPanel_ClassifyTxnsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedCount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "revenueCellPanel_ClassifyTxnsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ClassifyTxnsMutationPayload",
        "kind": "LinkedField",
        "name": "classifyTxns",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "revenueCellPanel_ClassifyTxnsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ClassifyTxnsMutationPayload",
        "kind": "LinkedField",
        "name": "classifyTxns",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "125a80fec62af7cd238d0b42024faba2",
    "id": null,
    "metadata": {},
    "name": "revenueCellPanel_ClassifyTxnsMutation",
    "operationKind": "mutation",
    "text": "mutation revenueCellPanel_ClassifyTxnsMutation(\n  $input: ClassifyTxnsInputObject!\n) {\n  classifyTxns(input: $input) {\n    updatedCount\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4da169f685c589a47837e3b15ae19561";

export default node;
